import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { G_API } from '../../constants/globalVar';
import SocialShareButtons from "../Button/SocialShareButtons";
import ReactGA from 'react-ga4';

export default function DetailPage(){
    const { id } = useParams();
    const [item, setItem] = useState(null);

    useEffect(() => {
        var data = '';
        var config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: G_API+'our-teams/OURTEAM_LIST?id='+id,
            headers: { },
            data : data
        };

        axios(config)
        .then( (response) => {
            const item = response.data.DATAS;
            setItem(item);
        })
        .catch(function (error) {
          console.error(error);
        });
    }, [id]);


    function openShare() {
        ReactGA.event({
            category: 'Publication',
            action: 'publication_share_btn_clicked',
            label: item ? item.title : 'Publication Share',
        });
    }

    return (
        <>
            {item ? (
                <div>
                    <div id="header-carousel" className="carousel slide" data-bs-ride="carousel" style={{ height: '180px', backgroundColor: '#002' }}>
                        </div>
                        <div className="container lh-lg">
                            <div className="bg-white rounded my-4 mx-auto py-5 px-5" style={{ margin: '0 auto', maxWidth: '800px' }}>
                                <div className="grid">
                                    <div className="row mb-4">
                                        <div className="col-12 col-md-4 mb-3">
                                            {item.profile_img.src ? (
                                                    <img className="w-100 h-auto rounded-4"  src={item.profile_img.src} alt="" />
                                            ) : (
                                                    <img className="w-100 h-auto rounded-4" src='/assets/images/anyar-logo.jpg' alt="" />
                                            )}
                                        </div>
                                        <div className="col-12 col-md-8">
                                            <h4 className="mb-4">{item.name}</h4>
                                            <h5>{item.position}</h5>
                                            <h5>{item.department}</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="my-4">
                                                <div dangerouslySetInnerHTML={{ __html: item.bio }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                        <SocialShareButtons title={item.name} onClick={openShare} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            ) : <div>
                    <span>Loading...</span>
            </div>}
        </>
    );
}
